'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileUAParts = require('./parts/MobileUAParts');

var _MobileUAParts2 = _interopRequireDefault(_MobileUAParts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IOS_UA_REGEX = new RegExp(_MobileUAParts2.default.ios);

exports.default = IOS_UA_REGEX;
module.exports = exports['default'];